// extracted by mini-css-extract-plugin
export default {"wrapper":"Mgi0SfAd","_shorts":"CMOPxRPn","caption":"pYkVI3Sv","video":"vX5FseRu"};